// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as AanmeldenRouteImport } from './routes/aanmelden'
import { Route as AanvraagRouteImport } from './routes/aanvraag'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as DienstenRouteImport } from './routes/diensten'
import { Route as HoeHetWerktRouteImport } from './routes/hoe-het-werkt'
import { Route as NetbeheerdersRouteImport } from './routes/netbeheerders'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as VeelgesteldeVragenRouteImport } from './routes/veelgestelde-vragen'
import { Route as WachtwoordInstellenRouteImport } from './routes/wachtwoord-instellen'
import { Route as WatKostEenElektricienRouteImport } from './routes/wat-kost-een-elektricien'
import { Route as AuthenticatedAccountRouteImport } from './routes/_authenticated/account'
import { Route as AuthenticatedAdminRouteImport } from './routes/_authenticated/admin'
import { Route as AuthenticatedDashboardRouteImport } from './routes/_authenticated/dashboard'
import { Route as AuthenticatedKlantbeheerRouteImport } from './routes/_authenticated/klantbeheer'
import { Route as AuthenticatedMijnAanvragenRouteImport } from './routes/_authenticated/mijn-aanvragen'
import { Route as AuthenticatedNieuwsBeheerRouteImport } from './routes/_authenticated/nieuws-beheer'
import { Route as AuthenticatedVakmannenBeheerRouteImport } from './routes/_authenticated/vakmannen-beheer'
import { Route as AuthenticatedVerzondenAanvragenRouteImport } from './routes/_authenticated/verzonden-aanvragen'
import { Route as AdminInloggenRouteImport } from './routes/admin_.inloggen'
import { Route as NieuwsIndexRouteImport } from './routes/nieuws.index'
import { Route as NieuwsSlugRouteImport } from './routes/nieuws.$slug'
import { Route as PlaatsenIndexRouteImport } from './routes/plaatsen.index'
import { Route as PlaatsenPlaatsRouteImport } from './routes/plaatsen.$plaats'
import { Route as VakmanIndexRouteImport } from './routes/vakman.index'
import { Route as VakmanAanmeldenRouteImport } from './routes/vakman.aanmelden'
import { Route as VakmanInstellingenRouteImport } from './routes/vakman.instellingen'
import { Route as VakmanTegoedRouteImport } from './routes/vakman.tegoed'
import { Route as AuthenticatedAccountIndexRouteImport } from './routes/_authenticated/account.index'
import { Route as AuthenticatedAccountOnderdeelRouteImport } from './routes/_authenticated/account.$onderdeel'
import { Route as ElektricienDienstIndexRouteImport } from './routes/elektricien.$dienst.index'
import { Route as ElektricienDienstPlaatsRouteImport } from './routes/elektricien.$dienst.$plaats'
import { Route as VakmanAanvraagIdRouteImport } from './routes/vakman.aanvraag.$id'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const AanmeldenRoute = AanmeldenRouteImport.update({
            id: '/aanmelden',path: '/aanmelden',getParentRoute: () => rootRouteImport
          })
const AanvraagRoute = AanvraagRouteImport.update({
            id: '/aanvraag',path: '/aanvraag',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const DienstenRoute = DienstenRouteImport.update({
            id: '/diensten',path: '/diensten',getParentRoute: () => rootRouteImport
          })
const HoeHetWerktRoute = HoeHetWerktRouteImport.update({
            id: '/hoe-het-werkt',path: '/hoe-het-werkt',getParentRoute: () => rootRouteImport
          })
const NetbeheerdersRoute = NetbeheerdersRouteImport.update({
            id: '/netbeheerders',path: '/netbeheerders',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const VeelgesteldeVragenRoute = VeelgesteldeVragenRouteImport.update({
            id: '/veelgestelde-vragen',path: '/veelgestelde-vragen',getParentRoute: () => rootRouteImport
          })
const WachtwoordInstellenRoute = WachtwoordInstellenRouteImport.update({
            id: '/wachtwoord-instellen',path: '/wachtwoord-instellen',getParentRoute: () => rootRouteImport
          })
const WatKostEenElektricienRoute = WatKostEenElektricienRouteImport.update({
            id: '/wat-kost-een-elektricien',path: '/wat-kost-een-elektricien',getParentRoute: () => rootRouteImport
          })
const AuthenticatedAccountRoute = AuthenticatedAccountRouteImport.update({
            id: '/account',path: '/account',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminRoute = AuthenticatedAdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedKlantbeheerRoute = AuthenticatedKlantbeheerRouteImport.update({
            id: '/klantbeheer',path: '/klantbeheer',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedMijnAanvragenRoute = AuthenticatedMijnAanvragenRouteImport.update({
            id: '/mijn-aanvragen',path: '/mijn-aanvragen',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedNieuwsBeheerRoute = AuthenticatedNieuwsBeheerRouteImport.update({
            id: '/nieuws-beheer',path: '/nieuws-beheer',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedVakmannenBeheerRoute = AuthenticatedVakmannenBeheerRouteImport.update({
            id: '/vakmannen-beheer',path: '/vakmannen-beheer',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedVerzondenAanvragenRoute = AuthenticatedVerzondenAanvragenRouteImport.update({
            id: '/verzonden-aanvragen',path: '/verzonden-aanvragen',getParentRoute: () => AuthenticatedRouteRoute
          })
const AdminInloggenRoute = AdminInloggenRouteImport.update({
            id: '/admin_/inloggen',path: '/admin/inloggen',getParentRoute: () => rootRouteImport
          })
const NieuwsIndexRoute = NieuwsIndexRouteImport.update({
            id: '/nieuws/',path: '/nieuws/',getParentRoute: () => rootRouteImport
          })
const NieuwsSlugRoute = NieuwsSlugRouteImport.update({
            id: '/nieuws/$slug',path: '/nieuws/$slug',getParentRoute: () => rootRouteImport
          })
const PlaatsenIndexRoute = PlaatsenIndexRouteImport.update({
            id: '/plaatsen/',path: '/plaatsen/',getParentRoute: () => rootRouteImport
          })
const PlaatsenPlaatsRoute = PlaatsenPlaatsRouteImport.update({
            id: '/plaatsen/$plaats',path: '/plaatsen/$plaats',getParentRoute: () => rootRouteImport
          })
const VakmanIndexRoute = VakmanIndexRouteImport.update({
            id: '/vakman/',path: '/vakman/',getParentRoute: () => rootRouteImport
          })
const VakmanAanmeldenRoute = VakmanAanmeldenRouteImport.update({
            id: '/vakman/aanmelden',path: '/vakman/aanmelden',getParentRoute: () => rootRouteImport
          })
const VakmanInstellingenRoute = VakmanInstellingenRouteImport.update({
            id: '/vakman/instellingen',path: '/vakman/instellingen',getParentRoute: () => rootRouteImport
          })
const VakmanTegoedRoute = VakmanTegoedRouteImport.update({
            id: '/vakman/tegoed',path: '/vakman/tegoed',getParentRoute: () => rootRouteImport
          })
const AuthenticatedAccountIndexRoute = AuthenticatedAccountIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedAccountRoute
          })
const AuthenticatedAccountOnderdeelRoute = AuthenticatedAccountOnderdeelRouteImport.update({
            id: '/$onderdeel',path: '/$onderdeel',getParentRoute: () => AuthenticatedAccountRoute
          })
const ElektricienDienstIndexRoute = ElektricienDienstIndexRouteImport.update({
            id: '/elektricien/$dienst/',path: '/elektricien/$dienst/',getParentRoute: () => rootRouteImport
          })
const ElektricienDienstPlaatsRoute = ElektricienDienstPlaatsRouteImport.update({
            id: '/elektricien/$dienst/$plaats',path: '/elektricien/$dienst/$plaats',getParentRoute: () => rootRouteImport
          })
const VakmanAanvraagIdRoute = VakmanAanvraagIdRouteImport.update({
            id: '/vakman/aanvraag/$id',path: '/vakman/aanvraag/$id',getParentRoute: () => rootRouteImport
          })





const AuthenticatedAccountRouteChildren = {
  AuthenticatedAccountOnderdeelRoute: AuthenticatedAccountOnderdeelRoute,AuthenticatedAccountIndexRoute: AuthenticatedAccountIndexRoute
}

const AuthenticatedAccountRouteWithChildren = AuthenticatedAccountRoute._addFileChildren(AuthenticatedAccountRouteChildren)



const AuthenticatedRouteRouteChildren = {
  AuthenticatedAccountRoute: AuthenticatedAccountRouteWithChildren,AuthenticatedAdminRoute: AuthenticatedAdminRoute,AuthenticatedDashboardRoute: AuthenticatedDashboardRoute,AuthenticatedKlantbeheerRoute: AuthenticatedKlantbeheerRoute,AuthenticatedMijnAanvragenRoute: AuthenticatedMijnAanvragenRoute,AuthenticatedNieuwsBeheerRoute: AuthenticatedNieuwsBeheerRoute,AuthenticatedVakmannenBeheerRoute: AuthenticatedVakmannenBeheerRoute,AuthenticatedVerzondenAanvragenRoute: AuthenticatedVerzondenAanvragenRoute
}

const AuthenticatedRouteRouteWithChildren = AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,AanmeldenRoute: AanmeldenRoute,AanvraagRoute: AanvraagRoute,AuthRoute: AuthRoute,ContactRoute: ContactRoute,DienstenRoute: DienstenRoute,HoeHetWerktRoute: HoeHetWerktRoute,NetbeheerdersRoute: NetbeheerdersRoute,PrivacyRoute: PrivacyRoute,VeelgesteldeVragenRoute: VeelgesteldeVragenRoute,WachtwoordInstellenRoute: WachtwoordInstellenRoute,WatKostEenElektricienRoute: WatKostEenElektricienRoute,AdminInloggenRoute: AdminInloggenRoute,NieuwsSlugRoute: NieuwsSlugRoute,PlaatsenPlaatsRoute: PlaatsenPlaatsRoute,VakmanAanmeldenRoute: VakmanAanmeldenRoute,VakmanInstellingenRoute: VakmanInstellingenRoute,VakmanTegoedRoute: VakmanTegoedRoute,NieuwsIndexRoute: NieuwsIndexRoute,PlaatsenIndexRoute: PlaatsenIndexRoute,VakmanIndexRoute: VakmanIndexRoute,ElektricienDienstPlaatsRoute: ElektricienDienstPlaatsRoute,VakmanAanvraagIdRoute: VakmanAanvraagIdRoute,ElektricienDienstIndexRoute: ElektricienDienstIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)